<template>
  <div class="salesman-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <el-select v-model="filterObj.shop_id">
            <el-option label="全部" value="0" />
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <b
            class="default-btn"
            :class="{ active: filterObj.search_calendar == '1' }"
            @click="selectDataForAccount"
          >
            只看工作日
          </b>
          <el-button type="primary" @click="getDataForAccount">查询</el-button>
        </div>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :data="dataInfo" border stripe max-height="800px">
        <el-table-column
          type="index"
          width="120"
          label="排名"
          align="center"
        />
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        />
        <el-table-column
          prop="data.C1"
          label="新签人数"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.D1"
          label="新签总额"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.C2"
          label="新签人数(单底大于等于3000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.D2"
          label="新签总额(单底大于等于3000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.C3"
          label="新签人数(单底小于3000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.D3"
          label="新签总额(单底小于3000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.C4"
          label="新签人数(单底大于等于2000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.D4"
          label="新签总额(单底大于等于2000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.C5"
          label="新签人数(单底小于2000)"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.D5"
          label="新签总额(单底小于2000)"
          sortable
          align="center"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'SalesmanStatistics',
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '0',
        search_calendar: '',
        key: 'C1,C2,C3,C4,C5,D1,D2,D3,D4,D5,B1'
      },
      shopList: [],
      dataInfo: [],
      init: true
    }
  },
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getMyShopList()
  },
  methods: {
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
      this.getDataForAccount()
    },
    getDataForAccount() {
      this.$http.getDataForAccount(this.filterObj).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.data.account_data
          this.dataInfo.forEach(e => {
            e.data.C1 = e.data.C1 ? e.data.C1 : 0
            e.data.C2 = e.data.C2 ? e.data.C2 : 0
            e.data.C3 = e.data.C3 ? e.data.C3 : 0
            e.data.C4 = e.data.C4 ? e.data.C4 : 0
            e.data.C5 = e.data.C5 ? e.data.C5 : 0
            e.data.D1 = e.data.D1 ? e.data.D1 / 100 : 0
            e.data.D2 = e.data.D2 ? e.data.D2 / 100 : 0
            e.data.D3 = e.data.D3 ? e.data.D3 / 100 : 0
            e.data.D4 = e.data.D4 ? e.data.D4 / 100 : 0
            e.data.D5 = e.data.D5 ? e.data.D5 / 100 : 0
            for (const key in e.data) {
              e.data[key] = parseInt(e.data[key])
            }
          })
        }
      })
    },
    updateShop(val) {
      this.filterObj.shop_id = val.join(',')
      if (this.init) {
        this.init = false
        this.getDataForAccount()
      }
    },
    selectDataForAccount() {
      this.filterObj.search_calendar =
        this.filterObj.search_calendar == '1' ? '' : '1'
    }
  }
}
</script>
<style lang="scss" scoped>
.salesman-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
  .search-box {
    margin-top: 20px;
  }
  .el-form-item {
    display: block;
    .el-input {
      width: 150px;
      margin-left: 30px;
      margin-right: 20px;
    }
    .el-form-item__content {
      width: 90%;
    }
  }
  .default-btn {
    display: inline-block;
    width: 150px;
    height: 40px;
    margin-left: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
    border-radius: 6px;
    border: solid 1px #dcdfe6;
    cursor: pointer;
    &.active {
      border: solid 1px #4c84ff;
      color: #4c84ff;
    }
  }
  .el-table td {
    div {
      text-align: center !important;
    }
    .cell {
      text-align: center !important;
    }
  }
}
</style>
